import React from "react";
import { observer } from "mobx-react";
import { Paginator } from "admin/_common/list/Paginator";
import { ListStore } from "_common/list/ListStore";
import { getUrlWithPagination } from "_common/_utils/searchUtils";
import { useHistory } from "react-router-dom";
import { DEFAULT_PAGE_SIZE } from "_common/resources/BaseResourceStore";

type Props = {
    listStore: ListStore<any>;
    className?: string;
};

export const ListStorePaginator = observer((props: Props) => {
    const history = useHistory();
    if (!props.listStore?.count) return null;
    if (props.listStore.count < DEFAULT_PAGE_SIZE + 1) return null;
    return (
        <Paginator
            onPageClick={(page) => {
                history.push(getUrlWithPagination(location.pathname, page) + location.search);
                props.listStore.setSelectedPage(page);
            }}
            count={props.listStore.count}
            selectedPage={props.listStore.selectedPage}
            pageSize={props.listStore.pageSize}
            className={props.className}
        />
    );
});
